
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.417 2.89h.001c1.105.511 2.34.766 3.704.766 1.419 0 2.682-.266 3.788-.801.455-.218.87-.478 1.244-.78.368-.298.638-.547.805-.746.08-.097.144-.18.187-.246a.708.708 0 00.052-.093.236.236 0 00-.033-.256.215.215 0 00-.16-.062.192.192 0 00-.087.024.51.51 0 00-.073.048c-.05.038-.11.093-.18.163-1.237 1.229-3.078 1.851-5.543 1.851h0c-2.455.004-4.318-.633-5.606-1.897a1.168 1.168 0 00-.135-.128.376.376 0 00-.063-.04.18.18 0 00-.079-.02h0-.005a.224.224 0 00-.155.064.224.224 0 00-.057.159c0 .035.013.07.025.096.013.029.032.06.055.095.045.068.11.153.196.254.174.207.456.462.84.764a6.62 6.62 0 001.28.785z","fill":"#000C1F","stroke":"#000C1F","stroke-width":".2"}}),_c('rect',{attrs:{"x":".622","y":"8.056","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    